
import { Observable } from 'rxjs';
import { DataDocumentSystemGenerateModel, DocumentSystemGenerateModel } from '../models/certificate/document-system-generate.model';

export abstract class CertificateRepository {

    abstract getDocumentsSystemGenerates(): Observable<DocumentSystemGenerateModel>;
    abstract insertDocumentSystemGenerate( params: DataDocumentSystemGenerateModel ):Observable<DocumentSystemGenerateModel>;
    abstract updateDocumentSystemGenerate( params: DataDocumentSystemGenerateModel ):Observable<DocumentSystemGenerateModel>;
    abstract updateDocumentSystemGenerate(params: DataDocumentSystemGenerateModel ): Observable<DocumentSystemGenerateModel>;
}